import { AuthBaseClient } from '../base-client';
import type { SearchResults } from './types';

/**
 * Client for global search API endpoint.
 */
export class SearchClient extends AuthBaseClient {
  /**
   * Search across all entity types.
   */
  async search(query: string, signal?: AbortSignal): Promise<SearchResults> {
    return this.post<SearchResults>('/api/search', { query }, signal);
  }
}
